import { Col, Row } from 'antd';
import React from 'react';
import { AppContent } from '@common/components';
import {
  InvoiceReviewFragmentType,
  ReverseInvoiceReviewFragmentType,
} from '@pay-bill/graphql';
import { BillingSummaryDetails } from './_billing-summary-details';
import { BillingSummaryCard } from './_billing-summary-card';
import { DisputesCard } from './_disputes-card';

type Props =
  | {
      isSupplier: true;
      invoiceData?: undefined;
      reverseInvoiceData: ReverseInvoiceReviewFragmentType;
    }
  | {
      isSupplier: false;
      invoiceData: InvoiceReviewFragmentType;
      reverseInvoiceData?: undefined;
    };

export const BillingSummaryTab = ({
  invoiceData,
  reverseInvoiceData,
  isSupplier,
}: Props) => {
  const invoice = isSupplier ? reverseInvoiceData.worksInvoice : invoiceData;

  const buildSummaryData = () => {
    if (isSupplier) {
      return {
        totalHours: reverseInvoiceData.totalHours,
        totalCents: reverseInvoiceData.totalCents,
        totalRemittanceCents: reverseInvoiceData.totalRemittanceCents,
        mspFeePercentage: reverseInvoiceData.mspFeePercentage,
        totalMspCents: reverseInvoiceData.totalMspCents,
        tierFeePercentage: reverseInvoiceData.tierFeePercentage,
        totalTierCents: reverseInvoiceData.totalTierCents,
      };
    }

    return {
      totalHours: invoiceData.totalHours,
      totalCents: invoiceData.totalCents,
    };
  };

  const buildInstallmentsData = () => {
    if (isSupplier) {
      return;
    }

    return {
      installments: invoiceData.invoiceInstallments,
      remainingInstallmentBalance: invoiceData.remainingInstallmentBalance,
      canCreate: invoiceData.canCreateInstallment,
      worksInvoiceId: invoiceData.id,
    };
  };

  return (
    <AppContent left={false} right={false}>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <BillingSummaryDetails invoice={invoice} isSupplier={isSupplier} />
        </Col>
        <Col span={12}>
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <BillingSummaryCard
                summaryData={buildSummaryData()}
                installmentsData={buildInstallmentsData()}
              />
            </Col>
            <Col span={24}>
              <DisputesCard
                disputesCountByState={
                  isSupplier
                    ? reverseInvoiceData.disputesCountByState
                    : invoiceData.disputesCountByState
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </AppContent>
  );
};
